import script from "./LinkApps.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkApps.vue?vue&type=script&setup=true&lang=js"

import "./LinkApps.vue?vue&type=style&index=0&id=4cf1cc5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf1cc5c"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
